export default {"src":"/_next/static/media/residential-land-icon.c1a524fa.svg","height":88,"width":111,"blurWidth":0,"blurHeight":0};